import { useEffect } from 'react'
import type { ProviderManagement } from '../types'

/**
 * Clears `selected` whenever it's no longer present in `options`
 * (e.g. after a refetch removes it from the valid list).
 */
export const useClearStaleSelection = (
  selected: ProviderManagement | null,
  options: ProviderManagement[],
  update: () => void,
) => {
  useEffect(() => {
    if (!selected) return
    if (!options.some((o) => o.cwsId === selected.cwsId)) update()
  }, [selected, options, update])
}
